module.exports = __webpack_public_path__ + "img/cpjs-img3.9714f85f.png";